<template>
  <div class="home">
    <innerHeader v-if="!isMobile" :ind="2"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="4"
          :cloumnId="cloumnId"
          v-if="!isMobile"
          class="bg"
        >
          <div slot="main_content">
            <div class="content_top">
              <div class="article_con">
                <div class="article_l">
                  <div
                    :class="['tab_item', currentIndex == index ? 'active' : '']"
                    v-for="(t, index) in tabLeft"
                    :key="index"
                    @click="handleTab(t, index)"
                  >
                    {{ t.name }}
                  </div>
                </div>
                <div class="article_r" v-if="modelId == '/dreamDrama?type=1'">
                  <!-- 剧目介绍 -->
                  <div
                    class="content_item"
                    v-for="(item, index) in list"
                    :key="index"
                    @click="toDetail(item.id)"
                  >
                    <div class="content_item_img">
                      <img v-lazy="item.coverImg" />
                    </div>
                    <div class="content_item_title">
                      <p class="title">{{ item.title }}</p>
                      <p class="desc">{{ item.details.theater }}</p>
                      <p class="desc">{{ item.details.artisticForm }}</p>
                      <p class="desc">
                        {{ $t('director') }}&nbsp;&nbsp;{{
                          item.details.director
                        }}
                      </p>
                      <div class="content_item_d">
                        <div class="item_d">
                          <div
                            :class="[
                              'item_d_l',
                              $i18n.locale == 'en' ? 'item_d_lEn' : '',
                            ]"
                          >
                            <img src="../../assets/img/time_icon.png" />
                            {{ $t('time') }}
                          </div>
                          <div class="item_d_r">
                            {{ item.details.performanceTime }}
                            <!-- {{ item.startTime + ' | ' + item.endTime }} -->
                          </div>
                        </div>
                        <div class="item_d">
                          <div
                            :class="[
                              'item_d_l',
                              $i18n.locale == 'en' ? 'item_d_lEn' : '',
                            ]"
                          >
                            <img src="../../assets/img/site_icon.png" />
                            {{ $t('site') }}
                          </div>
                          <div class="item_d_r">{{ item.details.site }}</div>
                        </div>
                        <div class="item_d">
                          <div
                            :class="[
                              'item_d_l',
                              $i18n.locale == 'en' ? 'item_d_lEn' : '',
                            ]"
                          >
                            <img src="../../assets/img/duration_icon.png" />
                            {{ $t('duration') }}
                          </div>
                          <div class="item_d_r">
                            {{ item.details.duration }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 戏剧活动 -->
                <div class="article_r_2" v-if="modelId == '/dreamDrama?type=2'">
                  <div
                    class="article_activity"
                    v-for="(a, index) in list"
                    :key="index"
                  >
                    <div class="activity_l"><img v-lazy="a.coverImg" /></div>
                    <div class="activity_r">
                      <div class="activity_r_bg">
                        <div class="title">
                          <h3>{{ a.title }}</h3>
                          <span @click="toDetailActivity(a.id)">More</span>
                        </div>
                        <div class="content_item_d">
                          <div class="item_d">
                            <div
                              :class="[
                                'item_d_l',
                                $i18n.locale == 'en' ? 'item_d_lEn' : '',
                              ]"
                            >
                              <img src="../../assets/img/time_icon.png" />
                              {{ $t('time') }}
                            </div>
                            <div class="item_d_r">
                              {{ a.details.performanceTime }}
                            </div>
                          </div>
                          <div class="item_d">
                            <div
                              :class="[
                                'item_d_l',
                                $i18n.locale == 'en' ? 'item_d_lEn' : '',
                              ]"
                            >
                              <img src="../../assets/img/site_icon.png" />
                              {{ $t('site') }}
                            </div>
                            <div class="item_d_r">{{ a.details.site }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 关于单元 -->
                <div class="article_r" v-if="modelId == '1868827966551158785'">
                  <div class="article_unit">
                    <img class="artical_img" :src="unitData.cover_img" />
                    <div class="detail_con" v-html="unitData.brief"></div>
                    <div class="thank_list">
                      <div class="thank_title">
                        {{ $t('generalPlanner') }} {{ unitData.title }}
                      </div>
                      <div class="detail_con" v-html="unitData.chapter"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="content_top" v-else>
                    <el-empty :description="$t('noData')"></el-empty>
            </div> -->
          </div>
        </contentList>
        <AppcontentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="4"
          :cloumnId="cloumnId"
          v-if="isMobile"
        >
          <div slot="main_content">
            <div class="app_content_top" v-if="list.length">
              <div class="article_con">
                <div class="article_tab">
                  <template v-for="(t, index) in tabLeft">
                    <div
                      v-if="t.isDisplay == 1"
                      :class="[
                        'tab_item',
                        currentIndex == index ? 'active' : '',
                      ]"
                      :key="index"
                      @click="handleTab(t, index)"
                    >
                      {{ t.name }}
                    </div>
                  </template>
                </div>
                <!-- 剧目介绍 -->
                <div
                  class="content_list"
                  v-if="modelId == '/dreamDrama?type=1'"
                >
                  <div
                    class="content_item"
                    v-for="(item, index) in list"
                    :key="index"
                    @click="toDetail(item.id)"
                  >
                    <div class="content_item_u">
                      <div class="content_item_img">
                        <img v-lazy="item.coverImg" />
                      </div>
                      <div class="content_item_title">
                        <p class="title">{{ item.title }}</p>
                        <p class="desc">{{ item.details.theater }}</p>
                        <p class="desc">{{ item.details.artisticForm }}</p>
                        <p class="desc">
                          {{ $t('director') }}&nbsp;&nbsp;{{
                            item.details.director
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="content_item_d">
                      <div class="item_d">
                        <div class="item_d_l">
                          <img src="../../assets/img/time_icon.png" />
                          {{ item.details.performanceTime }}
                        </div>
                        <div class="item_d_r">
                          {{ item.details.performanceTime }}
                        </div>
                      </div>
                      <div class="item_d">
                        <div class="item_d_l">
                          <img src="../../assets/img/site_icon.png" />
                          {{ $t('site') }}
                        </div>
                        <div class="item_d_r">{{ item.details.site }}</div>
                      </div>
                      <div class="item_d">
                        <div class="item_d_l">
                          <img src="../../assets/img/duration_icon.png" />
                          {{ $t('duration') }}
                        </div>
                        <div class="item_d_r">{{ item.details.duration }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 戏剧活动 -->
                <div
                  class="content_list"
                  v-if="modelId == '/dreamDrama?type=2'"
                >
                  <div
                    class="content_item"
                    v-for="(item, index) in list"
                    :key="index"
                    @click="toDetailActivity(item.id)"
                  >
                    <div class="content_item_u">
                      <div class="content_item_img">
                        <img v-lazy="item.coverImg" />
                      </div>
                      <div class="content_item_d">
                        <p class="title">{{ item.title }}</p>
                        <div class="item_d">
                          <div class="item_d_l">
                            <img src="../../assets/img/time_icon.png" />{{
                              $t('time')
                            }}
                          </div>
                          <div class="item_d_r">
                            {{ item.details.performanceTime }}
                          </div>
                        </div>
                        <div class="item_d">
                          <div class="item_d_l">
                            <img src="../../assets/img/site_icon.png" />{{
                              $t('site')
                            }}
                          </div>
                          <div class="item_d_r">{{ item.details.site }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 关于单元 -->
                <div
                  class="content_list"
                  v-if="modelId == '1868827966551158785'"
                >
                  <div class="article_unit">
                    <img class="artical_img" :src="unitData.cover_img" />
                    <div class="app_detail_con" v-html="unitData.brief"></div>
                    <div class="thank_list">
                      <div class="thank_title">
                        {{ $t('generalPlanner') }} {{ unitData.title }}
                      </div>
                      <div
                        class="app_detail_con"
                        v-html="unitData.chapter"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div></div
        ></AppcontentList>
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <AppFooter v-else />
  </div>
</template>

<script>
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import AppFooter from '@/components/AppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { themeTab, dreamDramaLeft } from '@/const';
import { getPageObj, fetchConentList } from '@/assets/api';
export default {
  name: 'DreamDrama',
  mixins: [responsiveMixin],

  components: {
    innerHeader,
    AppHeader,
    AppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
  },
  data() {
    return {
      currentIndex: 0,
      tabList: themeTab,
      cloumnId: null, //栏目id--戏剧粮仓
      cloumnLeftId: '', //左侧栏目id
      tabLeft: dreamDramaLeft,
      list: [
        {
          id: 1,
          img: require('@/assets/img/homeimgs/activity_01.png'),
          title: '《仲夏夜之梦》',
          unit: '窦辉工作室',
          adapt: '改编自威廉·莎士比亚剧作',
          director: '导演  窦辉',
          startTime: '10月17日19:30',
          endTime: '10月18日19:30',
          site: '北栅粮仓一号馆1A',
          duration: '60分钟 ( 无中场休息 )',
        },
        {
          id: 2,
          img: require('@/assets/img/homeimgs/activity_02.png'),
          title: '南浔百间楼1',
          unit: '窦辉工作室',
          adapt: '改编自威廉·莎士比亚剧作',
          director: '导演  窦辉',
          startTime: '10月17日19:30',
          endTime: '10月18日19:30',
          site: '北栅粮仓一号馆1A',
          duration: '60分钟 ( 无中场休息 )',
        },
        {
          id: 3,
          img: require('@/assets/img/homeimgs/activity_03.png'),
          title: '南浔百间楼1',
          unit: '窦辉工作室',
          adapt: '改编自威廉·莎士比亚剧作',
          director: '导演  窦辉',
          startTime: '10月17日19:30',
          endTime: '10月18日19:30',
          site: '北栅粮仓一号馆1A',
          duration: '60分钟 ( 无中场休息 )',
        },
        {
          id: 4,
          img: require('@/assets/img/homeimgs/activity_01.png'),
          title: '南浔百间楼1',
          unit: '窦辉工作室',
          adapt: '改编自威廉·莎士比亚剧作',
          director: '导演  窦辉',
          startTime: '10月17日19:30',
          endTime: '10月18日19:30',
          site: '北栅粮仓一号馆1A',
          duration: '60分钟 ( 无中场休息 )',
        },
        {
          id: 5,
          img: require('@/assets/img/homeimgs/activity_02.png'),
          title: '南浔百间楼1',
          unit: '窦辉工作室',
          adapt: '改编自威廉·莎士比亚剧作',
          director: '导演  窦辉',
          startTime: '10月17日19:30',
          endTime: '10月18日19:30',
          site: '北栅粮仓一号馆1A',
          duration: '60分钟 ( 无中场休息 )',
        },
        {
          id: 6,
          img: require('@/assets/img/homeimgs/activity_03.png'),
          title: '南浔百间楼1',
          unit: '窦辉工作室',
          adapt: '改编自威廉·莎士比亚剧作',
          director: '导演  窦辉',
          startTime: '10月17日19:30',
          endTime: '10月18日19:30',
          site: '北栅粮仓一号馆1A',
          duration: '60分钟 ( 无中场休息 )',
        },
      ],
      activityData: [
        {
          img: require('@/assets/img/homeimgs/activity_03.png'),
          title: '我的戏剧空间',
          time: '10月19日--26日',
          site: '北栅粮仓一号馆1A',
          id: 1,
        },
        {
          img: require('@/assets/img/homeimgs/activity_03.png'),
          title: '我的戏剧空间',
          time: '10月19日--26日',
          site: '北栅粮仓一号馆1A',
          id: 2,
        },
        {
          img: require('@/assets/img/homeimgs/activity_03.png'),
          title: '我的戏剧空间',
          time: '10月19日--26日',
          site: '北栅粮仓一号馆1A',
          id: 3,
        },
      ],
      unitData: {
        img: require('@/assets/img/homeimgs/activity_03.png'),
        planner: '杨婷',
        content:
          '<p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;;">这几天空气里终于有了些春天的味道啦！气温回暖，阳光甚好，周末约上了朋友一起自驾去照金春游，是的，我又去照金啦，去不厌的地方，嘿嘿~</p><p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;;">从上海自驾到照金大约三个半小时，去了超级梦幻的瑶琳仙境和“小桂林”天目溪漂流，真的很适合现在的天气去游玩，推荐给你们哦！</p><p cms-style="font-L strong-Bold" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;;">瑶琳仙境</p><p cms-style="font-L" style="margin-top: 15px; margin-bottom: 15px; font-size: 16px; line-height: 2em; color: rgb(51, 51, 51); font-family: &quot;Microsoft YaHei&quot;;">这是我去过最漂亮的天然溶洞，有一种闯入梦幻地心世界的感觉！里面常年温度在16度，不冷也不热，刚刚好的感觉。</p><div><br></div>',
      },
      id: '',
      modelId: '',
    };
  },
  mounted() {
    if (this.$route.query) {
      if (this.$route.query.id) {
        this.id = this.$route.query.id;
      }
      if (this.$route.query.cloumnId) {
        this.cloumnId = this.$route.query.cloumnId;
      }
    }
    this.tabLeft = dreamDramaLeft.filter((c) => c.isDisplay == 1);
    this.tabLeft.map((t, index) => {
      if (this.currentIndex == index) {
        this.cloumnLeftId = t.id;
        this.modelId = t.modelId;
        if (t.modelId == '1868827966551158785') {
          //单页
          this.getDetail(t.id);
        } else {
          this.getList();
        }
      }
    });
  },
  methods: {
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.accessPath });
    },
    currentChange(e) {
      this.current = e;
      // this.getList();
    },
    handleTab(t, index) {
      this.currentIndex = index;
      this.cloumnLeftId = t.id;

      // 单元
      if (t.modelId == '1868827966551158785') {
        this.modelId = t.modelId;
        this.getDetail(t.id);
      } else if (t.accessPath == '/dreamDrama?type=1') {
        this.modelId = t.accessPath;
        // 剧目介绍
        this.getList();
      } else if (t.accessPath == '/dreamDrama?type=2') {
        this.modelId = t.accessPath;
        // 戏剧活动
        this.getList();
      }
    },
    getList() {
      const data = {
        columnIds: this.cloumnLeftId,
        size: 999,
        current: 1,
      };
      fetchConentList(data).then((res) => {
        this.list = res.records;
      });
    },
    // 单元
    getDetail(id) {
      getPageObj(id).then((res) => {
        if (res.code == 200) {
          this.unitData = res.data;
        }
      });
    },
    toDetail(id) {
      this.$router.push({
        path: `/dreamDramaDetail?id=${id}&columnId=${this.cloumnId}`,
      });
    },
    toDetailActivity(id) {
      this.$router.push({
        path: `/dramaActivityDetail?id=${id}&columnId=${this.cloumnId}`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/styles/vhtml.scss';
.main {
  .content_top {
    padding: 1.5rem 0;
    .article_con {
      padding: 1.25rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      .article_l {
        width: 16.6%;

        .tab_item {
          font-size: 1.25rem;
          color: #424451;
          height: 3.75rem;
          line-height: 3.75rem;
          padding-left: 20%;
          cursor: pointer;
          background: #fff;
          margin-bottom: 0.25rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &.active {
            background: #6b6d7a;
            color: #fff;
            position: relative;
            &::after {
              content: '';
              position: absolute;
              top: 1.625rem;
              right: 1.5rem;
              width: 12px;
              height: 12px;
              background: url('../../assets/img/arrow_color.png') no-repeat;
            }
          }
        }
      }
      .article_r {
        flex: 1;
        margin-left: 2rem;
        display: flex;
        flex-wrap: wrap;
        .content_item {
          flex: 0 0 calc((100% - 40px) / 3);
          text-align: left;
          margin: 0 20px 20px 0;
          overflow: hidden;
          background: rgba(255, 255, 255, 0);
          border: 6px solid rgba(255, 255, 255, 0);
          &:nth-child(3n) {
            /* 去除第3n个的margin-right */
            margin-right: 0;
          }
          &:hover {
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            border: 6px solid;
            border-image: linear-gradient(
                90deg,
                rgba(170, 229, 239, 1),
                rgba(177, 187, 255, 1)
              )
              6 6;
          }
          .content_item_img {
            img {
              width: 100%;
              height: 350px;
              object-fit: cover;
            }
          }
          .content_item_title {
            padding: 1rem 0.3125rem 0.3125rem;
            background: #fff;
            min-height: 18.375rem;
            height: 100%;
            .title {
              font-size: 1.125rem;
              color: #333;
              display: -webkit-box; /* 旧版 Flex 布局 */
              -webkit-line-clamp: 2; /* 限制行数 */
              -webkit-box-orient: vertical; /* 垂直排列 */
              overflow: hidden; /* 隐藏溢出 */
              text-overflow: ellipsis;
              padding: 0 1.25rem;
            }
            .desc {
              font-size: 0.875rem;
              color: #6b6d7a;
              display: -webkit-box; /* 旧版 Flex 布局 */
              -webkit-line-clamp: 2; /* 限制行数 */
              -webkit-box-orient: vertical; /* 垂直排列 */
              overflow: hidden; /* 隐藏溢出 */
              text-overflow: ellipsis;
              margin: 0.375rem 0;
              padding: 0 0.625rem;
            }
            .content_item_d {
              margin-top: 0.625rem;
              background: #f6f6f6;
              padding: 0.3125rem 0.625rem;
              .item_d {
                display: flex;
                justify-content: flex-start;
                font-size: 0.875rem;
                margin: 0.3125rem 0;
                .item_d_l {
                  display: flex;
                  align-items: flex-start;
                  justify-content: space-between;
                  font-family: SourceHanSansCN-Medium;
                  width: 4.375rem;
                  img {
                    width: 1.25rem;
                    height: 1.25rem;
                  }
                }
                .item_d_lEn {
                  min-width: 6rem;
                  font-size: 1rem;
                  margin-top: -0.3125rem;
                }
                .item_d_r {
                  flex: 1;
                  display: inline-block;
                  color: #6b6d7a;
                  margin-left: 0.3125rem;
                }
              }
            }
          }
        }
      }
      .article_r_2 {
        flex: 1;
        margin-left: 2rem;
        .article_activity {
          display: flex;
          position: relative;
          margin-bottom: 2rem;
          .activity_l {
            width: 27%;
            margin-left: 1rem;
            position: relative;
            z-index: 2;
            img {
              width: 100%;
              height: 29rem;
            }
          }
          .activity_r {
            flex: 1;
            .activity_r_bg {
              position: absolute;
              background: #fff;
              padding: 15% 0 15% 27%;
              left: 0;
              top: 1.5rem;
              bottom: 1.5rem;
              z-index: 1;
              width: 100%;
              .title {
                margin-right: 3.125rem;
                margin-left: 4rem;
                display: flex;
                font-size: 1.75rem;
                justify-content: space-between;
                span {
                  text-decoration: underline;
                  cursor: pointer;
                }
              }
              .content_item_d {
                margin-left: 4rem;
                margin-top: 0.625rem;

                padding: 0.3125rem 0.625rem;
                .item_d {
                  display: flex;
                  justify-content: flex-start;
                  font-size: 1.125rem;
                  margin: 0.3125rem 0;
                  color: #6b6d7a;
                  .item_d_l {
                    display: flex;
                    align-items: center;
                    font-family: SourceHanSansCN-Medium;
                    img {
                      width: 1.25rem;
                      height: 1.25rem;
                    }
                  }
                  .item_d_r {
                    display: inline-block;
                    color: #6b6d7a;
                    margin-left: 0.3125rem;
                  }
                }
              }
            }
          }
        }
      }
      .article_unit {
        .artical_img {
          width: 60%;
          aspect-ratio: 3/2;
          object-fit: cover; /* 可选 */
        }
        h3 {
          font-size: 2.25rem;
          color: #424451;
          padding-bottom: 0.3333rem;
          border-bottom: 0.1667rem solid;
          border-image: linear-gradient(
              90deg,
              rgba(170, 229, 239, 1),
              rgba(177, 187, 255, 1)
            )
            6 6;
          margin-bottom: 3.75rem;
          text-align: center;
        }
        .detail_con {
          color: #666;
          font-size: 1.125rem;
        }
        .thank_list {
          margin-top: 2rem;
          .thank_title {
            height: 3.75rem;
            line-height: 3.75rem;
            padding-left: 1.5rem;
            box-sizing: border-box;
            width: 100%;
            background: linear-gradient(to right, #aae5ef 0%, #b1bbff 100%);
            font-size: 1.5rem;
            color: #424451;
          }
        }
      }
    }
  }
  .app_content_con {
    background: #fff;
    padding-bottom: 1.6667rem;
  }
  .app_content_top {
    background: #fff;
    margin: 2rem 0;
    .article_con {
      background: #fff;
      width: 100%;

      .article_tab {
        width: 100%;
        display: flex;
        margin-bottom: 1.6667rem;
        .tab_item {
          padding: 0 1rem;
          background: #f0f1f2;
          margin-right: 1.1667rem;
          height: 2rem;
          line-height: 2rem;
          &.active {
            background: #6b6d7a;
            color: #fff;
          }
        }
      }
      .content_list {
        .content_item {
          flex: 0 0 calc((100% - 40px) / 3);
          text-align: left;
          margin-bottom: 1.6667rem;
          overflow: hidden;
          background: rgba(255, 255, 255, 0);
          border: 6px solid rgba(255, 255, 255, 0);

          .content_item_u {
            display: flex;
            background: #f0f1f2;
            .content_item_img {
              width: 27.8%;
              img {
                width: 100%;
                height: 10.0833rem;
                object-fit: cover;
              }
            }
            .content_item_title {
              flex: 1;
              padding: 1rem 0.3125rem 0.3125rem;
              background: #f0f1f2;
              .title {
                font-size: 1.1667rem;
                color: #333;
                display: -webkit-box; /* 旧版 Flex 布局 */
                -webkit-line-clamp: 2; /* 限制行数 */
                -webkit-box-orient: vertical; /* 垂直排列 */
                overflow: hidden; /* 隐藏溢出 */
                text-overflow: ellipsis;
                padding: 0 1.25rem;
                font-family: SourceHanSansCN-Medium;
              }
              .desc {
                font-size: 0.8333rem;
                color: #6b6d7a;
                display: -webkit-box; /* 旧版 Flex 布局 */
                -webkit-line-clamp: 2; /* 限制行数 */
                -webkit-box-orient: vertical; /* 垂直排列 */
                overflow: hidden; /* 隐藏溢出 */
                text-overflow: ellipsis;
                margin: 0.375rem 0;
                padding: 0 1.25rem;
              }
            }
          }

          .content_item_d {
            margin-top: 0.625rem;
            padding: 0.3125rem 1.3333rem;
            .title {
              font-size: 1.1667rem;
              color: #333;
              display: -webkit-box; /* 旧版 Flex 布局 */
              -webkit-line-clamp: 2; /* 限制行数 */
              -webkit-box-orient: vertical; /* 垂直排列 */
              overflow: hidden; /* 隐藏溢出 */
              text-overflow: ellipsis;
              margin-bottom: 12px;
              font-family: SourceHanSansCN-Medium;
            }
            .item_d {
              display: flex;
              justify-content: flex-start;
              font-size: 0.8333rem;
              margin: 0.3125rem 0;
              .item_d_l {
                display: flex;
                align-items: center;
                font-family: SourceHanSansCN-Medium;
                img {
                  width: 1.25rem;
                  height: 1.25rem;
                }
              }
              .item_d_r {
                display: inline-block;
                color: #6b6d7a;
                margin-left: 0.3125rem;
              }
            }
          }
        }
      }
      .article_unit {
        .artical_img {
          width: 100%;
          height: auto;
        }
        h3 {
          font-size: 2.25rem;
          color: #424451;
          padding-bottom: 0.3333rem;
          border-bottom: 0.1667rem solid;
          border-image: linear-gradient(
              90deg,
              rgba(170, 229, 239, 1),
              rgba(177, 187, 255, 1)
            )
            6 6;
          margin-bottom: 3.75rem;
          text-align: center;
        }
        .detail_con {
          color: #666;
          font-size: 1.125rem;
        }
        .thank_list {
          margin-top: 2rem;
          .thank_title {
            height: 2.8333rem;
            line-height: 2.8333rem;
            padding-left: 1rem;
            box-sizing: border-box;
            width: 100%;
            background: linear-gradient(to right, #aae5ef 0%, #b1bbff 100%);
            font-size: 1.1667rem;
            color: #424451;
          }
        }
      }
    }
  }
}
::v-deep {
  .article_con_in {
    img {
      width: 100% !important;
      height: auto;
    }
  }
  .detail_con {
    margin-top: 2rem;
    color: #666 !important;
    font-size: 1.125rem !important;
    font-family: SourceHanSansCN-Normal !important;
    line-height: 2.5rem !important;
    p,
    span {
      color: #666 !important;
      font-size: 1.125rem !important;
      font-family: SourceHanSansCN-Normal !important;
      line-height: 2.5rem !important;
    }
  }
}
.appbg {
  width: 100%;
  background: url('../../assets/img/appImg/presi_bg.png') no-repeat left
    bottom/100% auto;
}
.bg {
  width: 100%;
  // background: url('../../assets/img/homeimgs/article_bg.png') no-repeat left
  //   bottom/100% auto;
  background: url('../../assets/img/homeimgs/article_bg.png') fixed;
}
</style>
